(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/header.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/header.js');
'use strict';

const SvsLogo = svs.playerRegistration.components.SvsLogo;
const Dots = svs.ui.ReactDots;
const ProductCylinderWrapper = svs.tb_ui_react.cylinder_wrapper.ProductCylinderWrapper;
const DesktopContentConstrain = svs.playerRegistration.components.DesktopContentConstrain;
const GridBase = svs.tb_ui_react.gridbase.GridBase;
const setStandardBranding = svs.playerRegistration.store.playerregistrationactions.setStandardBranding;
const GIFT = 'gift';

const Header = _ref => {
  let _ref$isForceStandardB = _ref.isForceStandardBranding,
    isForceStandardBranding = _ref$isForceStandardB === void 0 ? false : _ref$isForceStandardB;
  const dispatch = ReactRedux.useDispatch();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerregistrationreact),
    theme = _ReactRedux$useSelect.theme,
    productInfo = _ReactRedux$useSelect.productInfo,
    gift = _ReactRedux$useSelect.gift;
  const isProductInfo = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productInfo) && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productAmountInfo);
  React.useLayoutEffect(() => {
    isForceStandardBranding && dispatch(setStandardBranding());
  }, [dispatch, isForceStandardBranding]);
  const branding = gift ? GIFT : theme === null || theme === void 0 ? void 0 : theme.branding;
  return React.createElement("div", {
    className: "player-registration-header margin-0 padding-0 ".concat(theme === null || theme === void 0 ? void 0 : theme.fontColor)
  }, branding && React.createElement(ProductCylinderWrapper, {
    products: [branding]
  }), React.createElement("div", {
    className: "player-registration-header-content bg-tur-100 bg-".concat(branding),
    id: "player-registration-header"
  }, React.createElement("div", {
    className: "player-registration-header-content-logo margin-top-1 u-flex u-flex-justify-content-center"
  }, React.createElement(SvsLogo, {
    isNegative: theme === null || theme === void 0 ? void 0 : theme.isInverted
  })), isProductInfo && React.createElement(DesktopContentConstrain, null, React.createElement(GridBase, {
    className: "padding-top"
  }, React.createElement("div", {
    className: "u-flex main-content-constrained"
  }, React.createElement("div", {
    className: "u-flex-grow-1 align-left"
  }, !gift && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.productInfo)), React.createElement("div", {
    className: "align-right"
  }, !gift && isProductInfo && React.createElement("span", {
    className: "u-border-radius-6 padding ".concat(theme === null || theme === void 0 ? void 0 : theme.accentColor)
  }, productInfo === null || productInfo === void 0 ? void 0 : productInfo.productAmountInfo)))))), React.createElement(Dots, {
    branding: "player-registration-header-dots",
    className: "margin-bottom-1"
  }));
};
svs.playerRegistration.components.Header = Header;

 })(window);